<template>
  <select
    :id="id"
    :class="clazz"
    :name="id"
  >
  <option v-if="header" value="">{{ header }}</option>
  </select>
</template>

<script>
import Choices from "choices.js";

export default {
  name: "MaterialSelect",
  props: {
    id: {
      type: String,
      default: "choices-select",
    },
    clazz: {
      type: String,
      default: "",
    },
    header: {
      type: String,
      default: null
    },
    choices: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    choices: {
      handler(choices) {
        if (choices) {
          let ch = []
          choices.forEach(item => {
            ch.push({
              value: item.id,
              label: item.name
            })
          })
          if (document.getElementById(this.id)) {
            var element1 = document.getElementById(this.id);
            new Choices(element1, {
              searchEnabled: false,
              placeholder: true,
              placeholderValue: this.header,
              choices: ch
            });
          }
        }
      },
      immediate: true
    }
  },
};
</script>
